module.exports = __webpack_public_path__ + "img/wallet_color.34a901d1.png";